import React, { useState } from "react";
import FlowTable from "./FlowTable";
import AddFlowScreen from "./AddFlowScreen";
import { ToastContainer } from "react-toastify";

function Index() {
  const [isOpenAddFlow, setOpenAddFlow] = useState(false);
  const [editFlow, setEditFlow] = useState(null);

  const openAddFlow = () => {
    setEditFlow(null);
    setOpenAddFlow(true);
  };

  const openEditFlow = (row) => {
    setEditFlow({ id: row._id || row.id, data: row });
    setOpenAddFlow(true);
  };

  const closeFlowScreen = () => {
    setOpenAddFlow(false);
    setEditFlow(null);
  };

  return (
    <div>
      <ToastContainer />

      {isOpenAddFlow && (
        <AddFlowScreen
          flowId={editFlow?.id}
          initialData={editFlow?.data}
          onExit={closeFlowScreen}
          onSaveSuccess={() => setEditFlow(null)}
        />
      )}

      {!isOpenAddFlow && (
        <FlowTable onAddFlow={openAddFlow} onEditFlow={openEditFlow} />
      )}
    </div>
  );
}

export default Index;
